import { ssn } from '@xbcb/regex';
import { isValidEIN } from '../isValidEIN';
import { isValidCBPNumber } from '../isValidCBPNumber';

export const isValidIORNumber = (iorNumber, cbpPortCodes) =>
  isValidEIN(iorNumber) ||
  ssn.test(iorNumber) ||
  isValidCBPNumber(iorNumber, cbpPortCodes);
